function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, JSON, Object, endControlAvailable, endControlVisible, startControlAvailable, startControlVisible) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "style": $helpers.getStyle(),
        "class": {
          'scroll-control': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            visible: startControlVisible
          }, {
            'scroll-back-container': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((startControlAvailable) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "attrs": __vjadeStringifyAttrsIfObj({
                role: `button`,
                tabindex: 0,
              }),
              "on": {
                click: $helpers.scrollBack,
              },
              "class": {
                'scroll-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `arrow-left`
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            visible: endControlVisible
          }, {
            'scroll-forward-container': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((!endControlAvailable && startControlAvailable) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "attrs": __vjadeStringifyAttrsIfObj({
                role: `button`,
                tabindex: 0,
              }),
              "on": {
                click: $helpers.scrollBack,
              },
              "class": {
                'scroll-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `arrow-left`
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : (endControlAvailable) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "attrs": __vjadeStringifyAttrsIfObj({
                role: `button`,
                tabindex: 0,
              }),
              "on": {
                click: $helpers.scrollForward,
              },
              "class": {
                'scroll-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `arrow-right`
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "endControlAvailable" in locals ? locals.endControlAvailable : typeof endControlAvailable !== "undefined" ? endControlAvailable : undefined, "endControlVisible" in locals ? locals.endControlVisible : typeof endControlVisible !== "undefined" ? endControlVisible : undefined, "startControlAvailable" in locals ? locals.startControlAvailable : typeof startControlAvailable !== "undefined" ? startControlAvailable : undefined, "startControlVisible" in locals ? locals.startControlVisible : typeof startControlVisible !== "undefined" ? startControlVisible : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;